import React from 'react';
import { Carousel } from 'react-bootstrap';
import { ASSET_URL } from '../../../../env/Configurations';
import './Small-Banner-With-Title-Preview.scss';

const SmallWithTitlePreview = (props) => {
  const { config } = props;
  return (
    <div className='small-banner-title'>
      {config?.slides?.length && (
        <Carousel controls={false} indicators variant='dark'>
          {config.slides.map((slide, key) => (
            <Carousel.Item key={key}>
              {!slide?.isVideo && (
                <div
                  className={`d-flex align-items-center ${
                    slide?.shadowOverlay ? 'shadowed-img' : ''
                  }`}
                  key={key}
                  style={
                    slide.imgURL
                      ? {
                          backgroundImage: 'url(' + ASSET_URL + slide.imgURL + ')',
                          backgroundSize: 'cover',
                          height: '250px',
                          objectFit: 'cover',
                          width: '100%',
                          backgroundRepeat: 'no-repeat',
                        }
                      : {
                          backgroundRepeat: 'no-repeat',
                          height: '250px',
                        }
                  }
                >
                  {!slide.imgURL && <p className='image-text'>Image</p>}
                  <div
                    className='hero-banner-text'
                    style={slide.imgURL ? { color: 'white' } : { color: 'black' }}
                  >
                    <p className='hero-banner-text-title'>{slide.titleH2 || 'H2 Title'}</p>
                    {slide?.cta?.isActive && (
                      <p className='hero-banner-text-cta'>{slide?.cta?.title || 'CTA Title'}</p>
                    )}
                  </div>
                </div>
              )}

              {slide?.isVideo && (
                <div className={`${slide?.shadowOverlay ? 'shadowed-img' : ''}`} key={key}>
                  <div className='video-container'>
                    <video
                      style={{
                        width: '100%',
                        height: '250px',
                        objectFit: 'fill',
                        position: 'relative',
                        top: 0,
                        left: 0,
                      }}
                      autoPlay
                      loop={slide?.loopPlayBack}
                      preload='auto'
                      src={slide?.videoURL}
                      muted
                    />
                    {!slide.videoURL && <p className='image-text'>Video</p>}

                    <div
                      className='hero-banner-text-2'
                      style={slide.videoURL ? { color: 'white' } : { color: 'black' }}
                    >
                      <p className='hero-banner-text-2-title'>
                        {slide.titleH2 ? slide.titleH2 : 'H2 Title'}
                      </p>
                      {slide?.cta?.isActive && (
                        <p className='hero-banner-text-2-cta'>{slide?.cta?.title || 'CTA Title'}</p>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </Carousel.Item>
          ))}
        </Carousel>
      )}
    </div>
  );
};

export default SmallWithTitlePreview;
